<template>
  <SettingsRow
    v-if="show"
    name="Phone number fields"
    description="The Salesforce fields we bring in as phone numbers for your contacts and leads."
  >
    <SalesforcePhoneFields :disabled="!isAdmin" />
    <p v-if="!isAdmin" class="note">Your admin can change these.</p>
  </SettingsRow>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import SalesforcePhoneFields from '../../integrations/SalesforcePhoneFields.vue'
import { useCrmExport } from '../../../composables/useCrmExport'
import { useTelephony } from '../../../composables/useTelephony'
import { useCurrentUser } from '../../../../services/user'
import SettingsRow from './SettingsRow.vue'

const { isAdmin } = useTelephony()
const { isDialerOnly } = useCurrentUser()
const crmExport = useCrmExport()

// Full-product admins edit this under Integrations. The provider is the tenant's connected CRM, export on or off.
const show = computed(() => isDialerOnly.value && crmExport.provider.value === 'salesforce')

onMounted(() => {
  void crmExport.refresh()
})
</script>

<style scoped>
.note { margin: 0; font-size: var(--fs-xs); color: var(--color-text-tertiary); }
</style>
